import { StreamType } from '@wix/da-shared-react/pkg/Stream';
import { StreamInitConfig } from '@wix/da-shared-react/pkg/Stream/base/types';
import { StudioSection, StudioState } from './client/types/store';
import { fetchNextVideoGenerations } from './client/actions/studio/videoCreator';

export const XHR_BASE_PATH = '/_napi/da-editor-standalone/';
export const API_BASE_PATH = `${XHR_BASE_PATH}api`;
export const SHARED_API_BASE_PATH = `${XHR_BASE_PATH}shared_api`;

export const SAVED_SUBMISSIONS_FOLDER_NAME = 'Saved Submissions';
export const LITERATURE_DRAFTS_FOLDER_NAME = 'Literature Drafts';
export const JOURNAL_DRAFTS_FOLDER_NAME = 'Drafts';
export const DREAMUP_FOLDER_NAME = 'DreamUp';
export const MURO_FOLDER_NAME = 'Drawings';
export const WIXEL_FOLDER_NAME = 'Wixel';
export const VIDEO_FOLDER_NAME = 'Video';

export const STUDIO_DEVIATIONS_STREAM = {
  streamId: 'STUDIO_DEVIATIONS_STREAM',
  streamConfig: {
    autoFetch: false,
    streamType: StreamType.WITH_OFFSET,
  } as StreamInitConfig,
  streamThrottle: 500,
};

export const STUDIO_VIDEO_GENERATIONS_STREAM = {
  streamId: 'STUDIO_VIDEO_GENERATIONS_STREAM',
  streamConfig: {
    autoFetch: false,
    streamType: StreamType.WITH_OFFSET,
    fetchNextCallback: fetchNextVideoGenerations,
  } as StreamInitConfig,
  streamThrottle: 500,
};

export const STUDIO_BOOKMARKS_STREAM = {
  streamId: 'STUDIO_BOOKMARKS_STREAM',
  streamConfig: {
    autoFetch: false,
    streamType: StreamType.WITH_OFFSET,
    itemsPerFetch: 15,
  } as StreamInitConfig,
  streamThrottle: 500,
};

export const STASH_FOLDER_DEVIATIONS_STREAM = {
  streamId: 'STASH_FOLDER_DEVIATIONS_STREAM',
  streamConfig: {
    autoFetch: false,
    streamType: StreamType.WITH_OFFSET,
  } as StreamInitConfig,
  streamThrottle: 500,
};

export const STASH_SUBFOLDERS_STREAM = {
  streamId: 'STASH_SUBFOLDERS_STREAM',
  streamConfig: {
    autoFetch: false,
    streamType: StreamType.WITH_OFFSET,
    itemsPerFetch: 50,
  } as StreamInitConfig,
  streamThrottle: 500,
};

export const GALLERY_SUBFOLDERS_STREAM = {
  streamId: 'GALLERY_SUBFOLDERS_STREAM',
  streamConfig: {
    autoFetch: false,
    streamType: StreamType.WITH_OFFSET,
    itemsPerFetch: 50,
  } as StreamInitConfig,
  streamThrottle: 500,
};

export const GALLERY_FOLDER_DEVIATIONS_STREAM = {
  streamId: 'GALLERY_FOLDER_DEVIATIONS_STREAM',
  streamConfig: {
    autoFetch: false,
    streamType: StreamType.WITH_OFFSET,
  } as StreamInitConfig,
  streamThrottle: 500,
};

export const STUDIO_UPLOADS_NAMESPACE = 'studio';

export const BATCH_SCHEDULE_ERROR_MAXED_OUT = 1;
export const BATCH_SCHEDULE_ERROR_TIMESLOT_FULL = 2;

// based on web repo's attach_additional_image
// in vms/lib/bears/lifecycles/image/v./lib.bears.lifecycles.image.php$141
/** Backend filetypes that can be added to multi-image deviations */
export const MULTIIMAGE_ALLOWED_FILETYPES = ['gif', 'jpeg', 'png'];

export const SEARCHABLE_SECTIONS = [
  StudioSection.DRAFTS,
  StudioSection.STASH,
  StudioSection.LITERATURE,
  StudioSection.JOURNALS,
  StudioSection.PUBLISHED,
  StudioSection.PLAYGROUND,
];

export const EMPTY_SELECTION_STATE: StudioState['selection'] = {
  selectedRows: [],
  lastSelectedRow: null,
};


export const SELLER_DISCOUNTS_ACTIVE_STREAM = {
  streamId: 'SELLER_DISCOUNTS_ACTIVE_STREAM',
  streamConfig: {
    autoFetch: false,
    streamType: StreamType.WITH_OFFSET,
    itemsPerFetch: 50,
  } as StreamInitConfig,
  streamThrottle: 500,
};

export const SELLER_DISCOUNTS_SCHEDULED_STREAM = {
  streamId: 'SELLER_DISCOUNTS_SCHEDULED_STREAM',
  streamConfig: {
    autoFetch: false,
    streamType: StreamType.WITH_OFFSET,
    itemsPerFetch: 50,
  } as StreamInitConfig,
  streamThrottle: 500,
};

export const SELLER_DISCOUNTS_ENDED_STREAM = {
  streamId: 'SELLER_DISCOUNTS_ENDED_STREAM',
  streamConfig: {
    autoFetch: false,
    streamType: StreamType.WITH_OFFSET,
    itemsPerFetch: 50,
  } as StreamInitConfig,
  streamThrottle: 500,
};

export const STUDIO_EARNINGS_TRANSACTIONS_STREAM = {
  streamId: 'STUDIO_EARNINGS_TRANSACTIONS_STREAM',
  streamConfig: {
    autoFetch: false,
    streamType: StreamType.WITH_OFFSET,
    itemsPerFetch: 24,
  } as StreamInitConfig,
  streamThrottle: 500,
};

export const STUDIO_ORDERS_PENDING_STREAM = {
  streamId: 'STUDIO_ORDERS_PENDING',
  streamConfig: {
    autoFetch: false,
    streamType: StreamType.WITH_OFFSET,
  } as StreamInitConfig,
  streamThrottle: 500,
};

export const STUDIO_ORDERS_IN_PROGRESS_STREAM = {
  streamId: 'STUDIO_ORDERS_IN_PROGRESS',
  streamConfig: {
    autoFetch: false,
    streamType: StreamType.WITH_OFFSET,
  } as StreamInitConfig,
  streamThrottle: 500,
};

export const STUDIO_ORDERS_COMPLETED_STREAM = {
  streamId: 'STUDIO_ORDERS_COMPLETED',
  streamConfig: {
    autoFetch: false,
    streamType: StreamType.WITH_OFFSET,
  } as StreamInitConfig,
  streamThrottle: 500,
};

export const STUDIO_ORDERS_REJECTED_STREAM = {
  streamId: 'STUDIO_ORDERS_REJECTED',
  streamConfig: {
    autoFetch: false,
    streamType: StreamType.WITH_OFFSET,
  } as StreamInitConfig,
  streamThrottle: 500,
};

export const STUDIO_ORDERS_BY_DEVIATION_STREAM = {
  streamId: 'STUDIO_ORDERS_BY_DEVIATION', // root stream
  getStreamIdForDeviation: (deviationId: number) =>
    `STUDIO_ORDERS_BY_DEVIATION:${deviationId}`,
  streamConfig: {
    autoFetch: false,
    streamType: StreamType.WITH_OFFSET,
  } as StreamInitConfig,
  streamThrottle: 500,
};
